import { z } from "zod";
import { apiOSS as api, buildAuthHeaders } from "./apiOSS";

const WEBHOOK_STATUS_URL = `/settings/webhook`;
const WEBHOOK_RETRY_URL = `/settings/webhook/retry`;

export const webhookStatusSchema = z.object({
  webhookEnabled: z.boolean(),
  webhookStatusDetail: z.string().nullable(),
  webhookRequestsProcessing: z.number(),
  webhookRequestsFailed: z.number(),
});
export type WebhookStatus = z.infer<typeof webhookStatusSchema>;

export async function getWebhookStatus(apiKey: string): Promise<WebhookStatus | null> {
  const authHeaders = await buildAuthHeaders(apiKey);
  try {
    const resp = await api.get(WEBHOOK_STATUS_URL, authHeaders);
    return webhookStatusSchema.parse(resp.data);
  } catch (err) {
    // Fail silently b/c it might not exist after the account has been recently created.
    // Also, we load settings anyways, so we deal w/ error there.
    return null;
  }
}

export async function retryWebhookRequests(apiKey: string): Promise<void> {
  const authHeaders = await buildAuthHeaders(apiKey);
  await api.post(WEBHOOK_RETRY_URL, undefined, authHeaders);
}

export default api;
